"use strict";

exports.__esModule = true;
exports.Basic = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Basic implementation for supported animations.
 */
var Basic = /*#__PURE__*/function () {
  function Basic(element, target, lottie) {
    var _this = this;

    this.element = element;
    this.target = target;
    this.lottie = lottie;
    this.myInAnimation = false;
    this.myIsReady = false;
    this.myConnected = false;
    this.myEnterBound = this.enter.bind(this);
    this.myLeaveBound = this.leave.bind(this);

    var ready = function ready() {
      if (_this.myIsReady) {
        return;
      }

      _this.myIsReady = true;

      _this.ready();
    };

    lottie.addEventListener('complete', function () {
      _this.myInAnimation = false;

      _this.complete();
    });
    lottie.addEventListener('config_ready', ready);

    if (this.lottie.isLoaded) {
      ready();
    }
  }
  /**
   * The animation has been connected.
   */


  var _proto = Basic.prototype;

  _proto.connectedCallback = function connectedCallback() {
    this.myConnected = true;
  }
  /**
   * The animation has been disconnected.
   */
  ;

  _proto.disconnectedCallback = function disconnectedCallback() {
    this.myConnected = false;
  }
  /**
   * Callback for animation ready.
   */
  ;

  _proto.ready = function ready() {}
  /**
   * Callback for animation complete.
   */
  ;

  _proto.complete = function complete() {}
  /**
   * Callback for animation enter.
   */
  ;

  _proto.enter = function enter() {}
  /**
   * Callback for animation leave.
   */
  ;

  _proto.leave = function leave() {}
  /**
   * Play animation.
   */
  ;

  _proto.play = function play() {
    this.myInAnimation = true;
    this.lottie.play();
  }
  /**
   * Play animation from begining.
   */
  ;

  _proto.playFromBegining = function playFromBegining() {
    this.myInAnimation = true;
    this.lottie.goToAndPlay(0);
  }
  /**
   * Stop animation.
   */
  ;

  _proto.stop = function stop() {
    this.lottie.stop();
  }
  /**
   * Go to animation frame.
   * @param value
   */
  ;

  _proto.goToFrame = function goToFrame(value) {
    this.lottie.setCurrentRawFrameValue(value);
  }
  /**
   * Go to first animation frame.
   */
  ;

  _proto.goToFirstFrame = function goToFirstFrame() {
    this.goToFrame(0);
  }
  /**
   * Go to last animation frame.
   */
  ;

  _proto.goToLastFrame = function goToLastFrame() {
    this.goToFrame(Math.max(0, this.lottie.getDuration(true) - 1));
  }
  /**
   * Set direction of animation.
   * Forward (1) and backward (-1).
   */
  ;

  _proto.setDirection = function setDirection(direction) {
    this.lottie.setDirection(direction);
  }
  /**
   * Enable or disable loop for this animation.
   * @param value
   */
  ;

  _proto.setLoop = function setLoop(value) {
    this.lottie.loop = value;
  }
  /**
   * Controls speed of animation (1 is normal speed).
   * @param value
   */
  ;

  _proto.setSpeed = function setSpeed(value) {
    this.lottie.setSpeed(value);
  }
  /**
   * Checks whether the animation is in progress.
   */
  ;

  _createClass(Basic, [{
    key: "inAnimation",
    get: function get() {
      return this.myInAnimation;
    }
    /**
     * Check whether the animation is ready.
     */

  }, {
    key: "isReady",
    get: function get() {
      return this.myIsReady;
    }
    /**
     * Bounded version of enter callback.
     */

  }, {
    key: "enterBound",
    get: function get() {
      return this.myEnterBound;
    }
    /**
     * Bounded version of leave callback.
     */

  }, {
    key: "leaveBound",
    get: function get() {
      return this.myLeaveBound;
    }
    /**
     * Animation is connected.
     */

  }, {
    key: "connected",
    get: function get() {
      return this.myConnected;
    }
  }]);

  return Basic;
}();

exports.Basic = Basic;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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